module.exports = __webpack_public_path__ + "static/img/bg17.43b4831.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/bg17.jpg
// module id = ZaiB
// module chunks = 1